
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tienda",
      function () {
        return require("private-next-pages/tienda/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tienda"])
      });
    }
  